import QuestionMultipleChoiceUniqueAnswerComponent from './containers/questionMultipleChoiceUniqueAnswerComponent'

export { default as QuestionMultipleChoiceUniqueAnswerLayout } from './components/questionMultipleChoiceUniqueAnswerLayout' 

export default QuestionMultipleChoiceUniqueAnswerComponent